import axios from "axios";

export const GetRanksByCategory = async (catid: string) => {
  const res = await axios.get(`/api/ranks/cat/${catid}`);
  return res.data;
};

// Debates API functions
export const GetTrendingDebates = async (headers?: any) => {
  const res = await axios.get("/api/debates/trending", headers);
  return res.data;
};

export const GetDebate = async (debateId: string, headers?: any) => {
  const res = await axios.get(`/api/debates/${debateId}`, headers);
  return res.data;
};

export const GetPopularLists = async () => {
  const res = await axios.get("/api/popular-lists");
  return res.data;
};

// Admin Debates API functions
export const GetAllDebatesAdmin = async (headers: any) => {
  const res = await axios.get("/api/admin/debates", headers);
  return res.data;
};

export const GetDebateAdmin = async (debateId: string, headers: any) => {
  const res = await axios.get(`/api/admin/debates/${debateId}`, headers);
  return res.data;
};

export const GetCategory = async (catid: string) => {
  const res = await axios.get(`/api/categories/${catid}`);
  return res.data;
};

export const GetRandomUserList = async () => {
  const res = await axios.get(`/api/random-user-list`);
  return res.data;
};

export const GetUsersListById = async (listId: string) => {
  const res = await axios.get(`/api/list/${listId}`);
  return res.data;
};

export const GetListByIdUser = async (userid: string, category: string) => {
  const res = await axios.get(`/api/list/${category}/${userid}`);
  return res.data;
};

export const GetListByListTypeUser = async (
  userid: string,
  listTypeId: string,
) => {
  const res = await axios.get(`/api/list-type/${listTypeId}/${userid}`);
  return res.data;
};

export const GetUserByName = async (name: string) => {
  const res = await axios.get(`/api/user/${name}`);
  return res.data;
};

export const GetCategoryByName = async (name: string) => {
  const res = await axios.get(`/api/category/${name}`);
  return res.data;
};

export const GetRanksAllByCat = async (cat_id: string) => {
  const res = await axios.get(`/api/ranks/all/${cat_id}`);
  return res.data;
};

export const VerifyToken = async (token: string) => {
  const res = await axios.post(`/api/verify-recaptcha/`, { token: token });
  return res.data;
};

export const GetAnonToken = async () => {
  const res = await axios.get(`/api/get-anonymous-token`);
  return res.data;
};

export const RapperRanks = async () => {
  const res = await axios.get(`/api/generate-ranks`);
  return res.data;
};

export const RanksByCatGen = async (catid: string, gen: number) => {
  const res = await axios.get(`/api/ranks/cat/${catid}/gen/${gen}`);
  return res.data;
};

export const GetAppStats = async (headers) => {
  const res = await axios.post(`/api/site-stats`, {}, headers);
  return res.data;
};

export const GetAdminDashboard = async (headers: any) => {
  const res = await axios.get(`/api/admin/dashboard`, headers);
  return res.data;
};

export const GetAllLists = async () => {
  const res = await axios.get(`/api/get-all-lists`);
  return res.data;
};

export const GetCategoriesWithListTypes = async () => {
  const res = await axios.get(`/api/categories-with-list-types`);
  return res.data;
};

export const GetLatestUsers = async (headers) => {
  const res = await axios.post(`/api/get-latest-users`, {}, headers);
  return res.data;
};

// Metadata Admin API functions
export const GetMetadataAdmin = async (
  params: {
    page?: number;
    limit?: number;
    reviewStatus?: string;
    categoryId?: string;
    sourceType?: string;
  },
  headers: any,
) => {
  const queryParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      queryParams.append(key, value.toString());
    }
  });

  const res = await axios.get(`/api/admin/metadata?${queryParams}`, headers);
  return res.data;
};

export const GetMetadataStatsAdmin = async (headers: any) => {
  const res = await axios.get(`/api/admin/metadata/stats`, headers);
  return res.data;
};

// Profile Statistics API functions
export const GetUserStats = async (userId: string, headers?: any) => {
  const res = await axios.get(`/api/user-stats/${userId}`, headers);
  return res.data;
};

export const GetTasteProfile = async (userId: string, headers?: any) => {
  const res = await axios.get(`/api/taste-profile/${userId}`, headers);
  return res.data;
};

// Get all lists for a specific user
export const GetAllUserLists = async (userId: string) => {
  const res = await axios.get(`/api/user-lists/${userId}`);
  return res.data;
};

// Get current user profile
export const GetProfile = async (headers: any) => {
  const res = await axios.get("/api/profile", headers);
  return res.data;
};

// Get rapper profile by slug
export const GetRapperProfile = async (slug: string) => {
  const res = await axios.get(`/api/rappers/${slug}`);
  return res.data;
};
